import {
  ArrowBack,
  ArrowForward,
  Assignment,
  ChatBubbleOutline,
  CheckCircle,
  ChevronRightOutlined,
  Close,
  ContentPaste,
  Delete,
  Description,
  ExpandLess,
  ExpandMore,
  //   FileUpload,
  FilterList,
  GetApp,
  HelpOutline,
  Info,
  // KeyboardArrowDown,
  Person,
  Refresh,
  Schedule,
  Upload,
} from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  Input,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Buffer } from "buffer";
import saveAs from "file-saver";
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import MonetaryInput from "src/Components/Common/MonetaryInput";
import useFetch from "src/Components/Common/useFetch";
import CustomToast from "src/Components/CustomToast";
import ReactTable from "src/Components/ReactTable/ReactTable";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { filterDateBetweenStartAndEndDate, formatDate } from "src/Utils/DateUtils";
import {
  trackReconDisputedEntriesDownloaded,
  trackReconDisputeEntriesViewed,
  trackReconRaiseOtherIssuesViewed,
} from "src/Utils/Mixpanel/VendorPortalEvents";
import { formatMoney, ToDineroObj } from "src/Utils/MoneyUtils";
import { DependencyType, SummaryStatus } from "../../DisputeResolution/DisputedEntries/constants/disputeEntries";
import RejectedInvoicesFiltersBars from "../../DisputeResolution/RejectedInvoices/RejectedInvoicesFiltersBars";
import { useVendorPortal } from "../VendorPortalLayout";
import NonReconVpFilterOfDisputedEntries from "./Non-Recon/NonReconVpFilterOfDisputedEntries";
import NonReconVpRemarksDisputedEntries from "./Non-Recon/NonReconVpRemarksDisputedEntries";
import NonReconVpTakeActionDisputedEntries from "./Non-Recon/NonReconVpTakeActionDisputedEntries";
import VpBulkActionDisputedEntries from "./VpBulkActionDisputedEntries";
import VpEntryDetailsDisputedEntries from "./VpEntryDetailsDisputedEntries";
import VpFilterOfDisputedEntries from "./VpFilterOfDisputedEntries";
import VpRemarksDisputedEntries from "./VpRemarksDisputedEntries";
import VpTakeActionDisputedEntries from "./VpTakeActionDisputedEntries";
import VpUploadDocument from "./VpUploadDocument";

const VpDisputedEntries = ({ isNonReconViewPage }) => {
  const { handleUnauthorizedError, isSessionReady, token, userPan } = useVendorPortal();
  const [selectedRows, setSelectedRows] = useState({});
  const [filters, setFilters] = useState([]);
  const [tableLoader] = useState(false);
  const [openFilterOfDisputedEntries, setOpenFilterOfDisputedEntries] = useState(false);
  const [openNonReconFilterOfDisputedEntries, setOpenNonReconFilterOfDisputedEntries] = useState(false);
  const [openBulkActionModal, setOpenBulkActionModal] = useState(false);
  const [showDetailSummaryTable, setShowDetailSummaryTable] = useState(false);
  const [selectedRowOfDisputedEntryForModal, setSelectedRowOfDisputedEntryForModal] = useState();
  const [openTakeActionModal, setOpenTakeActionModal] = useState(false);
  const [openNonReconTakeActionModal, setOpenNonReconTakeActionModal] = useState(false);
  const [openEntryDetailsModal, setOpenEntryDetailsModal] = useState(false);
  const [openRemarksModal, setOpenRemarksModal] = useState(false);
  const [openNonReconRemarksModal, setOpenNonReconRemarksModal] = useState(false);
  const [pendingExpanded, setPendingExpanded] = useState(true);
  const [resolvedExpanded, setResolvedExpanded] = useState(true);
  const [openVpUploadDocument, setOpenVpUploadDocument] = useState(false);
  const [titleOfDisputedEntryDetails, setTitleOfDisputedEntryDetails] = useState(null);
  const hideTakeActionButtonForThisTitle = ["In Progress by Instamart", "Resolved by Instamart", "Resolved by Vendor"];

  // api
  const [allDisputedEntriesData, setAllDisputedEntriesData] = useState([]);
  const [disputedEntriesData, setDisputedEntriesData] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("All");
  const [allOrganizations, setAllOrganizations] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [loaderListVendorPortalDr, setLoaderListVendorPortalDr] = useState(false);
  const [nonReconIssuesMenuAnchor, setNonReconIssuesMenuAnchor] = useState<null | HTMLElement>(null);
  const isNonReconIssuesMenuOpen = Boolean(nonReconIssuesMenuAnchor);
  const [consolidatedSummaryData, setConsolidatedSummaryData] = useState([]);
  const [latestApiCallId, setLatestApiCallId] = useState(0);
  //
  const [isNonReconViewRaisedIssues, setIsNonReconViewRaisedIssues] = useState(isNonReconViewPage);
  const [showAddNewIssue, setShowAddNewIssue] = useState(false);

  // Add New Issue form states
  const [selectedIssueTab, setSelectedIssueTab] = useState(0);

  // Manual/Bulk mode states for each tab
  const [invoiceMissingMode, setInvoiceMissingMode] = useState("manual"); // 'manual' or 'bulk'
  const [prRtvMode, setPrRtvMode] = useState("manual"); // 'manual' or 'bulk'

  // Invoice Missing Issue form states
  const [organisationName, setOrganisationName] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  // Add Issue Confirmation Modal state
  const [openAddIssueConfirmModal, setOpenAddIssueConfirmModal] = useState(false);

  // PR/RTV Issue form states
  const [prRtvOrganisationName, setPrRtvOrganisationName] = useState("");
  const [debitNoteNumber, setDebitNoteNumber] = useState("");
  const [prRtvInvoiceNumber, setPrRtvInvoiceNumber] = useState("");
  const [debitNoteDate, setDebitNoteDate] = useState("");
  const [debitNoteAmount, setDebitNoteAmount] = useState("");
  const [disputedAmount, setDisputedAmount] = useState("");
  const [prRtvRemark, setPrRtvRemark] = useState("");
  const [prRtvConfirmed, setPrRtvConfirmed] = useState(false);

  // File upload states
  const [fileInputPod, setFileInputPod] = useState<HTMLInputElement | null>(null);
  const [fileInputInvoice, setFileInputInvoice] = useState<HTMLInputElement | null>(null);
  const [uploadedPodFiles, setUploadedPodFiles] = useState([]);
  const [uploadedInvoiceFiles, setUploadedInvoiceFiles] = useState([]);

  // PR/RTV Issue file upload states
  const [fileInputPrRtvSupporting, setFileInputPrRtvSupporting] = useState<HTMLInputElement | null>(null);
  const [uploadedPrRtvSupportingFiles, setUploadedPrRtvSupportingFiles] = useState([]);

  // Bulk upload states
  const [fileInputBulk, setFileInputBulk] = useState<HTMLInputElement | null>(null);
  const [isLoadingAddNewIssueSubmit, setIsLoadingAddNewIssueSubmit] = useState(false);
  const [isDownloadingForNonRecon, setIsDownloadingForNonRecon] = useState(false);

  // Bulk upload validation modal states
  const [showBulkValidationModal, setShowBulkValidationModal] = useState(false);
  const [bulkValidationData, setBulkValidationData] = useState(null);

  // Define ReactTable columns
  const columnDefinition = useMemo(
    (): any => [
      {
        header: "Resolution Status",
        id: "resolutionStatus",
        accessorFn: (row) => row.resolutionStatus || "",
        filterVariant: "multi-select",
        size: 250,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let chipColor: "primary" | "warning" | "success" | "default" | "secondary" | "error" | "info" = "default";

          // Use SummaryStatus enum for consistent status matching
          switch (status) {
            case SummaryStatus.Resolved:
              chipColor = "success";
              break;
            case SummaryStatus.ReviewPending:
            case SummaryStatus.ClarificationPending:
            case SummaryStatus.BookingPending:
              chipColor = "warning";
              break;
            case SummaryStatus.ApprovedForBooking:
              chipColor = "info";
              break;
            case SummaryStatus.DocsPending:
              chipColor = "secondary";
              break;
            case SummaryStatus.LeadershipApprovalRequired:
            case SummaryStatus.RequireConfirmation:
              chipColor = "error";
              break;
            default:
              chipColor = "default";
              break;
          }

          return <Chip label={status} size="small" color={chipColor} variant="filled" sx={{ fontWeight: 400 }} />;
        },
      },
      {
        header: "Action ",
        id: "action",
        accessorFn: (row) => row.action || "",
        filterVariant: "multi-select",
        size: 350,
      },
      {
        header: "Dependency",
        id: "dependency",
        filterVariant: "multi-select",
        accessorFn: (row) => row.dependency || "",
        size: 180,
      },
      {
        header: "Gap reason",
        id: "gapReason",
        accessorFn: (row) => row.gapReason || "",
        filterVariant: "multi-select",
        size: 350,
      },
      {
        header: "Disputed Amount",
        id: "disputedAmount",
        accessorFn: (row) => parseFloat(row.disputedAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.disputedAmount ? formatMoney(ToDineroObj(row.original?.disputedAmount)) : ""}
          >
            {row.original?.disputedAmount ? formatMoney(ToDineroObj(row.original?.disputedAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Recon Status",
        id: "reconStatus",
        accessorFn: (row) => row.reconStatus || "",
        filterVariant: "multi-select",
        size: 350,
      },

      {
        header: "Doc type",
        id: "docType",
        accessorFn: (row) => row.docType || "",
        filterVariant: "multi-select",
        size: 180,
      },
      // {
      //   header: "Remarks (Instamart)",
      //   id: "remarksInstamart",
      //   accessorFn: (row) => row.remarksInstamart || "",
      //   size: 180,
      // },
      // {
      //   header: "Remarks (Vendor)",
      //   id: "remarksVendor",
      //   accessorFn: (row) => row.remarksVendor || "",
      //   size: 180,
      // },

      {
        header: "Vendor Invoice Number",
        id: "vendorInvoiceNumber",
        accessorFn: (row) => row.vendorInvoiceNumber || "",
        size: 230,
      },
      {
        header: "Instamart DN Number",
        id: "instamartDnNumber",
        accessorFn: (row) => row.instamartDnNumber || "",
        size: 230,
      },
      {
        header: "Vendor CN Number",
        id: "vendorCnNumber",
        accessorFn: (row) => row.vendorCnNumber || "",
        size: 230,
      },

      {
        header: "Comments",
        id: "newComments",
        accessorFn: (row) => (row.newComments ? "Unread" : "Read"),
        size: 180,
        filterVariant: "multi-select",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {/*  its boolean */}
            {row.original?.newComments ? "Unread" : "Read"}
          </div>
        ),
      },

      {
        header: "Dispute Status",
        id: "vendorDisputeStatus",
        accessorFn: (row) => row.vendorDisputeStatus || "",
        filterVariant: "multi-select",
        size: 230,
      },
      {
        header: "Entity",
        id: "entity",
        accessorFn: (row) => row.entity || "",
        filterVariant: "multi-select",
        size: 180,
      },

      {
        header: "Actions",
        id: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        size: hideTakeActionButtonForThisTitle.includes(titleOfDisputedEntryDetails) ? 150 : 235,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {!hideTakeActionButtonForThisTitle.includes(titleOfDisputedEntryDetails) && (
              <CustomButton
                size="small"
                variant="outlined"
                colorToken="violet"
                className="heading-xxs"
                onClick={() => {
                  setSelectedRowOfDisputedEntryForModal(row.original);
                  setOpenTakeActionModal(true);
                }}
              >
                Take action
              </CustomButton>
            )}

            {titleOfDisputedEntryDetails !== "In Progress by Instamart" &&
              (isNonReconViewRaisedIssues ||
                (titleOfDisputedEntryDetails !== "Resolved by Instamart" &&
                  titleOfDisputedEntryDetails !== "Resolved by Vendor")) && (
                <IconButton
                  size="small"
                  sx={{ color: "#531c4c" }}
                  onClick={() => {
                    setSelectedRowOfDisputedEntryForModal(row.original);
                    setOpenRemarksModal(true);
                  }}
                >
                  <Tooltip title="Remarks">
                    <ChatBubbleOutline />
                  </Tooltip>
                </IconButton>
              )}

            <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenEntryDetailsModal(true);
              }}
            >
              <Tooltip title="Entry Details">
                <ContentPaste />
              </Tooltip>
            </IconButton>
            {/* <IconButton
                     size="small"
                     sx={{ color: "#531c4c" }}
                    //  onClick={() => {
                    //    setSelectedRowOfDisputedEntryForModal(row.original);
                    //    setOpenViewHistoryModal(true);
                    //  }}
                   >
                     <Tooltip title="View History">
                       <AccessTime />
                     </Tooltip>
                   </IconButton> */}
          </Box>
        ),
      },
    ],
    [titleOfDisputedEntryDetails]
  );
  const columnDefinitionNonRecon = useMemo(
    (): any => [
      {
        header: "Resolution Status",
        id: "resolutionStatus",
        accessorFn: (row) => row.resolutionStatus || "",
        filterVariant: "multi-select",
        size: 250,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let chipColor: "primary" | "warning" | "success" | "default" | "secondary" | "error" | "info" = "default";

          // Use SummaryStatus enum for consistent status matching
          switch (status) {
            case SummaryStatus.Resolved:
              chipColor = "success";
              break;
            case SummaryStatus.ReviewPending:
            case SummaryStatus.ClarificationPending:
            case SummaryStatus.BookingPending:
              chipColor = "warning";
              break;
            case SummaryStatus.ApprovedForBooking:
              chipColor = "info";
              break;
            case SummaryStatus.DocsPending:
              chipColor = "secondary";
              break;
            case SummaryStatus.LeadershipApprovalRequired:
            case SummaryStatus.RequireConfirmation:
              chipColor = "error";
              break;
            default:
              chipColor = "default";
              break;
          }

          return <Chip label={status} size="small" color={chipColor} variant="filled" sx={{ fontWeight: 400 }} />;
        },
      },
      {
        header: "Action ",
        id: "action",
        accessorFn: (row) => row.action || "",
        filterVariant: "multi-select",
        size: 350,
      },
      {
        header: "Dependency",
        id: "dependency",
        filterVariant: "multi-select",
        accessorFn: (row) => row.dependency || "",
        size: 180,
      },
      {
        header: "Invoice Amount",
        id: "invoiceAmount",
        accessorFn: (row) => parseFloat(row.invoiceAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.invoiceAmount ? formatMoney(ToDineroObj(row.original?.invoiceAmount)) : ""}
          >
            {row.original?.invoiceAmount ? formatMoney(ToDineroObj(row.original?.invoiceAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Debit Note Amount",
        id: "dncnAmount",
        accessorFn: (row) => parseFloat(row.dncnAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.dncnAmount ? formatMoney(ToDineroObj(row.original?.dncnAmount)) : ""}
          >
            {row.original?.dncnAmount ? formatMoney(ToDineroObj(row.original?.dncnAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Disputed Amount",
        id: "disputedAmount",
        accessorFn: (row) => parseFloat(row.disputedAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.disputedAmount ? formatMoney(ToDineroObj(row.original?.disputedAmount)) : ""}
          >
            {row.original?.disputedAmount ? formatMoney(ToDineroObj(row.original?.disputedAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Doc type",
        id: "docType",
        accessorFn: (row) => row.docType || "",
        filterVariant: "multi-select",
        size: 180,
      },

      {
        header: "Invoice Number",
        id: "invoiceNumber",
        accessorFn: (row) => row.invoiceNumber || "",
        size: 230,
      },
      {
        header: "Instamart DN Number",
        id: "instamartDNNumber",
        accessorFn: (row) => row.instamartDNNumber || "",
        size: 230,
      },

      {
        header: "Invoice date",
        id: "invoiceDate",
        accessorFn: (row) => row.invoiceDate || "",
        size: 320,
        filterVariant: "date-range",

        filterFn: (row, _, filterValue) => {
          const startDate = filterValue[0] && filterValue[0].$d;
          const endDate = filterValue[1] && filterValue[1].$d;
          return filterDateBetweenStartAndEndDate(startDate, endDate, row.original.invoiceDate);
        },
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.invoiceDate ? formatDate(row.original?.invoiceDate) : "-"}
          </div>
        ),
      },
      {
        header: "Debit note date",
        id: "debitNoteDate",
        accessorFn: (row) => row.debitNoteDate || "",
        size: 320,
        filterVariant: "date-range",

        filterFn: (row, _, filterValue) => {
          const startDate = filterValue[0] && filterValue[0].$d;
          const endDate = filterValue[1] && filterValue[1].$d;
          return filterDateBetweenStartAndEndDate(startDate, endDate, row.original.debitNoteDate);
        },
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.debitNoteDate ? formatDate(row.original?.debitNoteDate) : "-"}
          </div>
        ),
      },

      {
        header: "Organization name",
        id: "organizationName",
        accessorFn: (row) => row.organizationName || "",
        filterVariant: "multi-select",
        size: 280,
      },
      {
        header: "PO number",
        id: "poNumber",
        accessorFn: (row) => row.poNumber || "",
        filterVariant: "multi-select",
        size: 280,
      },

      {
        header: "Actions",
        id: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        size: hideTakeActionButtonForThisTitle.includes(titleOfDisputedEntryDetails) ? 130 : 235,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {!hideTakeActionButtonForThisTitle.includes(titleOfDisputedEntryDetails) && (
              <CustomButton
                size="small"
                variant="outlined"
                colorToken="violet"
                className="heading-xxs"
                onClick={() => {
                  setSelectedRowOfDisputedEntryForModal(row.original);
                  setOpenNonReconTakeActionModal(true);
                }}
              >
                Take action
              </CustomButton>
            )}

            {titleOfDisputedEntryDetails !== "In Progress by Instamart" &&
              (isNonReconViewRaisedIssues ||
                (titleOfDisputedEntryDetails !== "Resolved by Instamart" &&
                  titleOfDisputedEntryDetails !== "Resolved by Vendor")) && (
                <IconButton
                  size="small"
                  sx={{ color: "#531c4c" }}
                  onClick={() => {
                    setSelectedRowOfDisputedEntryForModal(row.original);
                    setOpenNonReconRemarksModal(true);
                  }}
                >
                  <Tooltip title="Remarks">
                    <ChatBubbleOutline />
                  </Tooltip>
                </IconButton>
              )}
            {/* <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenEntryDetailsModal(true);
              }}
            >
              <Tooltip title="Entry Details">
                <ContentPaste />
              </Tooltip>
            </IconButton> */}
            {/* <IconButton
                     size="small"
                     sx={{ color: "#531c4c" }}
                    //  onClick={() => {
                    //    setSelectedRowOfDisputedEntryForModal(row.original);
                    //    setOpenViewHistoryModal(true);
                    //  }}
                   >
                     <Tooltip title="View History">
                       <AccessTime />
                     </Tooltip>
                   </IconButton> */}
          </Box>
        ),
      },
    ],
    [titleOfDisputedEntryDetails]
  );

  useEffect(() => {
    // Only run when session is ready
    if (!isSessionReady) return;

    if (token) {
      // If token exists, use it to fetch data
      if (isNonReconViewPage) {
        trackReconRaiseOtherIssuesViewed();
      }
      handleReconOrNonReconView(isNonReconViewPage);
      getAllCompanies(token);
    } else {
      // If no token, show error
      toast.error(<CustomToast message="Session expired. Please log in again." />);
    }
  }, [isSessionReady, token, isNonReconViewPage]); // Depend on both isSessionReady and token

  const getAllCompanies = (token) => {
    useFetch(API_ENDPOINTS.FETCH_VP_LEDGER_SUMMARY_GET_ALL_COMPANIES.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_VP_LEDGER_SUMMARY_GET_ALL_COMPANIES.failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        const companies = response.data.data || [];

        // Companies that should appear at the bottom
        const bottomCompanies = ["POspark", "Supr", "SPWAVE- Swiggy Daily", "Scootsy Assure"];

        // Separate companies into two groups
        const regularCompanies = companies.filter((company) => !bottomCompanies.includes(company.companyName));
        const specialCompanies = companies.filter((company) => bottomCompanies.includes(company.companyName));

        // Sort regular companies alphabetically by companyName
        regularCompanies.sort((a, b) => a.companyName.localeCompare(b.companyName, undefined, { sensitivity: "base" }));

        // Combine: regular companies first (sorted), then special companies at bottom
        const sortedCompanies = [...regularCompanies, ...specialCompanies];

        setAllCompanies(sortedCompanies);
      },
      catchCallBack: (error) => {
        handleUnauthorizedError(error);
      },
    });
  };

  const listVendorPortalDr = async (token, isNonReconView = false) => {
    setLoaderListVendorPortalDr(true);

    // Increment API call ID to track the latest call
    const apiCallId = Date.now();
    setLatestApiCallId(apiCallId);

    // For now using same API endpoint, but can be changed based on isNonReconView in future
    const apiEndpoint = isNonReconView ? API_ENDPOINTS.VENDOR_PORTAL_DR_NON_RECON : API_ENDPOINTS.VENDOR_PORTAL_DR;
    await useFetch(apiEndpoint.url, "GET", {
      failureMessage: apiEndpoint.failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        // Only update state if this is the most recent API call
        setLatestApiCallId((latestId) => {
          if (apiCallId === latestId) {
            setLoaderListVendorPortalDr(false);
            setAllDisputedEntriesData(response.data.data || []);
            // Generate summary data from Excel data
            const summary = generateSummaryFromData(response.data.data || [], isNonReconView);
            // Generate consolidated summary data
            const consolidatedSummary = generateConsolidatedSummaryData(summary);

            setConsolidatedSummaryData(consolidatedSummary);
            setDisputedEntriesData(response.data.data || []);

            if (!isNonReconView) {
              trackReconDisputeEntriesViewed({
                render_ok: true,
                has_data: (response.data.data || []).length > 0,
              });
            }
            // ...existing code...
            // here if isNonReconView then need to take entry.organizationName
            const organizations = Array.from(
              new Set(
                response.data.data.flatMap((entry) =>
                  isNonReconView
                    ? entry.organizationName
                      ? [entry.organizationName.trim()].filter(Boolean)
                      : []
                    : entry.entity
                    ? entry.entity
                        .split(",")
                        .map((e) => e.trim())
                        .filter(Boolean)
                    : []
                )
              )
            );
            setAllOrganizations(organizations);
          } else {
            // This is a stale response, ignore it
            console.log("Ignoring stale API response", latestApiCallId);
          }
          return latestId; // Return the latest ID unchanged
        });
      },
      catchCallBack: (error) => {
        // Only update loader state if this is the most recent API call
        setLatestApiCallId((latestId) => {
          if (apiCallId === latestId) {
            setLoaderListVendorPortalDr(false);
            handleUnauthorizedError(error);
          }
          return latestId;
        });
      },
    });
  };

  // Function to generate consolidated summary data from Excel data
  const generateConsolidatedSummaryData = (summaryFromExcel) => {
    // Define the mapping from dependency + status to consolidated categories
    const statusMapping = {
      // Vendor mappings
      "vendor_Docs Pending": { title: "Docs Pending by Vendor", status: "Pending" },
      "vendor_Booking Pending": { title: "Booking Pending by Vendor", status: "Pending" },
      "vendor_Clarification Pending": { title: "Clarification Pending by Vendor", status: "Pending" },
      vendor_Resolved: { title: "Resolved by Vendor", status: "Resolved" },

      // Finance mappings
      "finance_Review Pending": { title: "In Progress by Instamart", status: "Pending" },
      "finance_Approved for Booking": { title: "In Progress by Instamart", status: "Pending" },
      finance_Resolved: { title: "Resolved by Instamart", status: "Resolved" },
      "finance_Docs Pending": { title: "In Progress by Instamart", status: "Pending" },

      // Warehouse mappings
      "warehouse_Docs Pending": { title: "In Progress by Instamart", status: "Pending" },
      "warehouse_Clarification Pending": { title: "In Progress by Instamart", status: "Pending" },
      "warehouse_Leadership Approval Required": { title: "In Progress by Instamart", status: "Pending" },

      // Procurement mappings
      "procurement_Require Confirmation": { title: "In Progress by Instamart", status: "Pending" },

      // AR Team mappings
      "arTeam_Clarification Pending": { title: "In Progress by Instamart", status: "Pending" },

      // BTPL mappings
      // "btpl_Clarification Pending": { title: "In Progress by Instamart", status: "Pending" },
      "category_Require Confirmation": { title: "In Progress by Instamart", status: "Pending" },
    };

    // Initialize consolidated data structure
    const consolidatedData = {
      "Docs Pending by Vendor": {
        title: "Docs Pending by Vendor",
        amount: 0,
        count: 0,
        dependencies: [],
        status: "Pending",
        resolutionStatuses: [],
      },
      "In Progress by Instamart": {
        title: "In Progress by Instamart",
        amount: 0,
        count: 0,
        dependencies: [],
        status: "Pending",
        resolutionStatuses: [],
      },
      "Booking Pending by Vendor": {
        title: "Booking Pending by Vendor",
        amount: 0,
        count: 0,
        dependencies: [],
        status: "Pending",
        resolutionStatuses: [],
      },
      "Clarification Pending by Vendor": {
        title: "Clarification Pending by Vendor",
        amount: 0,
        count: 0,
        dependencies: [],
        status: "Pending",
        resolutionStatuses: [],
      },
      "Resolved by Instamart": {
        title: "Resolved by Instamart",
        amount: 0,
        count: 0,
        dependencies: [],
        status: "Resolved",
        resolutionStatuses: [],
      },
      "Resolved by Vendor": {
        title: "Resolved by Vendor",
        amount: 0,
        count: 0,
        dependencies: [],
        status: "Resolved",
        resolutionStatuses: [],
      },
    };

    // Process each dependency's data
    Object.keys(summaryFromExcel).forEach((dependency) => {
      const dependencyData = summaryFromExcel[dependency];

      dependencyData.forEach((item) => {
        const mappingKey = `${dependency}_${item.title}`;
        const mapping = statusMapping[mappingKey];

        if (mapping) {
          const consolidatedTitle = mapping.title;

          // Convert amount string to number for aggregation
          const amountStr = item.amount.replace(/[₹,]/g, "");
          const amountNum = parseInt(amountStr) || 0;

          // Add to consolidated data
          consolidatedData[consolidatedTitle].amount += amountNum;
          consolidatedData[consolidatedTitle].count += item.count;

          // Add dependency if not already included
          if (!consolidatedData[consolidatedTitle].dependencies.includes(item.dependency)) {
            consolidatedData[consolidatedTitle].dependencies.push(item.dependency);
          }

          // Add original resolution status if not already included
          if (!consolidatedData[consolidatedTitle].resolutionStatuses.includes(item.title)) {
            consolidatedData[consolidatedTitle].resolutionStatuses.push(item.title);
          }
        }
      });
    });

    // Convert to array format and format amounts
    const summaryArray = Object.values(consolidatedData)
      .map((item) => ({
        title: item.title,
        amount: `₹${item.amount.toLocaleString("en-IN")}`,
        count: item.count,
        dependency: item.dependencies,
        status: item.status,
        resolutionStatuses: item.resolutionStatuses,
      }))
      .filter((item) => item.count > 0); // Only include items with actual data

    return summaryArray;
  };

  // Enhanced Summary Card Component with descriptions and view details
  const EnhancedSummaryCard = ({ data, onViewDetails }: { data: any; onViewDetails: () => void }) => {
    const { icon, bgColor, iconColor, description } = getEnhancedSummaryCardProperties(data.title);

    return (
      <Card
        sx={{
          background: "#ffffff",
          borderRadius: 1,
          border: "1px solid rgba(0,0,0,0.12)",
          boxShadow: "0px 0px 8px 4px rgba(0,0,0,0.02)",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 180, // Set minimum height for consistent card sizing
          overflow: "hidden",
        }}
      >
        {/* Top Section */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            flex: 1, // Take up remaining space
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 1,
                backgroundColor: bgColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: iconColor,
              }}
            >
              {icon}
            </Box>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: 1.3,
                color: iconColor,
                letterSpacing: "0.024px",
              }}
            >
              {data.title}
            </Typography>
          </Box>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: 1.4,
              color: "rgba(0,0,0,0.6)",
              letterSpacing: "0.035px",
              minHeight: "36px", // Set minimum height for description to maintain alignment
              display: "flex",
              alignItems: "flex-start", // Align text to top of the container
            }}
          >
            {description}
          </Typography>
        </Box>

        {/* Bottom Section - Fixed height */}
        <Box
          sx={{
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0, // Prevent shrinking
            minHeight: "64px", // Fixed height for bottom section
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: 1.3,
              color: "rgba(0,0,0,0.87)",
              letterSpacing: "0.03px",
            }}
          >
            {data.amount} ({data.count})
          </Typography>
          <CustomButton
            size="small"
            variant="outlined"
            sx={{
              minWidth: "auto",
              px: 1.5,
              py: 0.5,
              borderColor: `${iconColor}80`, // 50% opacity
              color: iconColor,
              fontSize: "14px",
              fontWeight: 600,
              letterSpacing: "0.014px",
              "&:hover": {
                borderColor: iconColor,
                backgroundColor: `${iconColor}08`, // 3% opacity
              },
            }}
            endIcon={<ChevronRightOutlined />}
            onClick={onViewDetails}
          >
            View details
          </CustomButton>
        </Box>
      </Card>
    );
  };

  // Enhanced properties function with descriptions
  const getEnhancedSummaryCardProperties = (title) => {
    const consolidatedMappings = {
      "Docs Pending by Vendor": {
        icon: <Assignment sx={{ fontSize: 16 }} />,
        bgColor: "#bbdefb",
        iconColor: "#0288d1",
        description:
          "Click to filter the cases where the Instamart team require necessary documents and details for resolution.",
      },
      "In Progress by Instamart": {
        icon: <Refresh sx={{ fontSize: 16 }} />,
        bgColor: "#bbdefb",
        iconColor: "#0288d1",
        description: "Click to filter the cases where Instamart team is investigating or pending for booking.",
      },
      "Booking Pending by Vendor": {
        icon: <Schedule sx={{ fontSize: 16 }} />,
        bgColor: "#ffecb3",
        iconColor: "#ef6c00",
        description: "Click to filter the cases where Instamart has submitted the required details for booking.",
      },
      "Clarification Pending by Vendor": {
        icon: <HelpOutline sx={{ fontSize: 16 }} />,
        bgColor: "#ffecb3",
        iconColor: "#ef6c00",
        description:
          "Click to filter cases needing Instamart team's clarity, add remarks after investigation, and attach docs if required.",
      },
      "Resolved by Instamart": {
        icon: <CheckCircle sx={{ fontSize: 20 }} />,
        bgColor: "#c8e6c9",
        iconColor: "#2e7d32",
        description: "Click to filter the cases where Instamart has made the rectification in their ledger.",
      },
      "Resolved by Vendor": {
        icon: <Person sx={{ fontSize: 20 }} />,
        bgColor: "#c8e6c9",
        iconColor: "#2e7d32",
        description: "Click to filter the cases where you (Vendor) has made the rectification entries.",
      },
    };

    return (
      consolidatedMappings[title] || {
        icon: <Assignment sx={{ fontSize: 16 }} />,
        bgColor: "#bbdefb",
        iconColor: "#0288d1",
        description: "Click to view details of this category.",
      }
    );
  };

  // Function to handle view details click
  const handleViewDetails = (data) => {
    setTitleOfDisputedEntryDetails(data.title);
    setFilters([
      {
        id: "dependency",
        value: data.dependency,
      },
      {
        id: "resolutionStatus",
        value: data.resolutionStatuses || [], // Use the array of original resolution statuses
      },
    ]);
    setShowDetailSummaryTable(true);
  };

  // Function to calculate totals for each section
  const calculateSectionTotals = (data) => {
    const pendingCategories = [
      "Docs Pending by Vendor",
      "In Progress by Instamart",
      "Booking Pending by Vendor",
      "Clarification Pending by Vendor",
    ];
    const resolvedCategories = ["Resolved by Instamart", "Resolved by Vendor"];

    const pending = data.filter((item) => pendingCategories.includes(item.title));
    const resolved = data.filter((item) => resolvedCategories.includes(item.title));

    const calculateTotal = (items) => {
      const totalAmount = items.reduce((sum, item) => {
        const amount = parseInt(item.amount.replace(/[₹,]/g, "")) || 0;
        return sum + amount;
      }, 0);
      const totalCount = items.reduce((sum, item) => sum + item.count, 0);
      return { amount: totalAmount, count: totalCount };
    };

    return {
      pending: calculateTotal(pending),
      resolved: calculateTotal(resolved),
      pendingItems: pending,
      resolvedItems: resolved,
    };
  };

  // Function to generate summary data from Excel data based on dependency and resolution status
  const generateSummaryFromData = (excelData, isNonReconView = false) => {
    // Define the dependencies in the same order as summaryData
    const dependencyOrder = [
      "finance",
      "warehouse",
      "procurement",
      "arTeam",
      //  "btpl",
      "category",
      "vendor",
    ];

    // Create a mapping for dependency names using DependencyType enum
    const dependencyMapping = {
      finance: DependencyType.Finance,
      warehouse: DependencyType.Warehouse,
      procurement: DependencyType.Procurement,
      arteam: DependencyType.ARTeam,
      arTeam: DependencyType.ARTeam,
      // btpl: DependencyType.BTPL,
      category: DependencyType.Category,
      vendor: DependencyType.Vendor,
    };

    const summaryResult = {};

    // Initialize all dependencies with empty arrays
    dependencyOrder.forEach((dep) => {
      summaryResult[dep] = [];
    });

    // Group data by dependency
    const groupedByDependency = {};

    excelData.forEach((row) => {
      const dependency = row.dependency?.toString().toLowerCase().trim() || "";
      const resolutionStatus = row.resolutionStatus?.toString().trim() || "";
      const disputedAmount = isNonReconView
        ? (parseFloat(row.dncnAmount) || 0) + (parseFloat(row.invoiceAmount) || 0)
        : parseFloat(row.disputedAmount) || 0;

      // Map dependency to our key format
      let dependencyKey = "";
      Object.keys(dependencyMapping).forEach((key) => {
        if (dependencyMapping[key].toLowerCase() === dependency.toLowerCase()) {
          dependencyKey = key;
        }
      });

      if (dependencyKey && resolutionStatus) {
        if (!groupedByDependency[dependencyKey]) {
          groupedByDependency[dependencyKey] = {};
        }

        if (!groupedByDependency[dependencyKey][resolutionStatus]) {
          groupedByDependency[dependencyKey][resolutionStatus] = {
            count: 0,
            totalAmount: 0,
          };
        }

        groupedByDependency[dependencyKey][resolutionStatus].count += 1;
        groupedByDependency[dependencyKey][resolutionStatus].totalAmount += disputedAmount;
      }
    });

    // Convert grouped data to summaryData format
    Object.keys(groupedByDependency).forEach((dependency) => {
      const statuses = groupedByDependency[dependency];

      Object.keys(statuses).forEach((status) => {
        const { count, totalAmount } = statuses[status];
        const formattedAmount =
          totalAmount >= 0
            ? `₹${Math.abs(Math.round(totalAmount)).toLocaleString("en-IN")}`
            : `-₹${Math.abs(Math.round(totalAmount)).toLocaleString("en-IN")}`;

        summaryResult[dependency].push({
          title: status,
          amount: formattedAmount,
          count: count,
          dependency: dependencyMapping[dependency], // Add dependency field
        });
      });
    });

    return summaryResult;
  };

  const changeOrganization = (org) => {
    // ...existing code...
    const filteredData =
      org === "All"
        ? allDisputedEntriesData
        : allDisputedEntriesData.filter((entry) =>
            isNonReconViewRaisedIssues
              ? entry.organizationName === org
              : entry.entity
                  ?.split(",")
                  .map((e) => e.trim())
                  .includes(org)
          );
    setSelectedOrganization(org);

    // Generate summary data from Excel data
    const summary = generateSummaryFromData(filteredData, isNonReconViewRaisedIssues);
    // Generate consolidated summary data
    const consolidatedSummary = generateConsolidatedSummaryData(summary);

    setConsolidatedSummaryData(consolidatedSummary);
    setDisputedEntriesData(filteredData);
    // ...existing code...
  };

  // File upload handlers
  const handlePODFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedPodFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = "";
      return;
    }

    setUploadedPodFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handleInvoiceFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedInvoiceFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = "";
      return;
    }

    setUploadedInvoiceFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handleDeletePodFile = (index) => {
    setUploadedPodFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeleteInvoiceFile = (index) => {
    setUploadedInvoiceFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // PR/RTV Issue file upload handlers
  const handlePrRtvSupportingFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedPrRtvSupportingFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = "";
      return;
    }

    setUploadedPrRtvSupportingFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handleDeletePrRtvSupportingFile = (index) => {
    setUploadedPrRtvSupportingFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // Bulk upload handlers
  const handleBulkFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Call handleAddBulkIssue for bulk upload processing
      handleAddBulkIssue(selectedFile);
    }
    event.target.value = "";
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      // Call handleAddBulkIssue for bulk upload processing
      handleAddBulkIssue(droppedFile);
    }
  };

  // Function to download Excel file
  const handleDownloadExcel = () => {
    setIsDownloading(true);
    const apiEndpoint = isNonReconViewRaisedIssues
      ? API_ENDPOINTS.VENDOR_PORTAL_DR_NON_RECON_DOWNLOAD_REPORT
      : API_ENDPOINTS.VENDOR_PORTAL_DR_DOWNLOAD_REPORT;
    useFetch(apiEndpoint.url, "GET", {
      failureMessage: apiEndpoint.failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        const filename = isNonReconViewRaisedIssues
          ? `${userPan}_Other issues list.xlsx`
          : `Disputed_Entries_Report.xlsx`;
        const excelData = Buffer.from(response.data.data, "base64");
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([excelData], { type: fileType });
        saveAs(blob, filename);
        trackReconDisputedEntriesDownloaded();
        setIsDownloading(false);
      },
      catchCallBack: () => {
        setIsDownloading(false);
      },
    });
  };

  const handleDownloadExcelForNonRecon = () => {
    setIsDownloadingForNonRecon(true);
    const apiEndpoint =
      selectedIssueTab === 0 ? API_ENDPOINTS.DOWNLOAD_INVOICE_TEMPLATE : API_ENDPOINTS.DOWNLOAD_PR_RTV_TEMPLATE;
    useFetch(apiEndpoint.url, "GET", {
      failureMessage: apiEndpoint.failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        const filename =
          selectedIssueTab === 0
            ? `Invoice missing cases raise issues format.xlsx`
            : `PR & RTV issues upload format.xlsx`;
        const excelData = Buffer.from(response.data.data.template, "base64");
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([excelData], { type: fileType });
        saveAs(blob, filename);
        setIsDownloadingForNonRecon(false);
      },
      catchCallBack: () => {
        setIsDownloadingForNonRecon(false);
      },
    });
  };

  const handleReconOrNonReconView = (isNonReconView) => {
    setShowDetailSummaryTable(false);
    setNonReconIssuesMenuAnchor(null);
    setIsNonReconViewRaisedIssues(isNonReconView);
    setConsolidatedSummaryData([]);
    setAllDisputedEntriesData([]);
    setDisputedEntriesData([]);
    setSelectedOrganization("All");
    setLoaderListVendorPortalDr(true);
    listVendorPortalDr(token, isNonReconView);
  };

  // Handle Add Issue button click
  const handleAddIssueClick = () => {
    setOpenAddIssueConfirmModal(true);
  };

  // Validation functions for form fields
  const isInvoiceMissingFormValid = () => {
    return (
      organisationName &&
      organisationName.trim() &&
      invoiceNumber &&
      invoiceNumber.trim() &&
      poNumber &&
      poNumber.trim() &&
      invoiceDate &&
      invoiceDate.trim() &&
      invoiceAmount &&
      invoiceAmount.toString().trim() &&
      confirmed &&
      uploadedPodFiles.length > 0
    );
  };

  const isPrRtvFormValid = () => {
    return (
      prRtvOrganisationName &&
      prRtvOrganisationName.trim() &&
      debitNoteNumber &&
      debitNoteNumber.trim() &&
      prRtvInvoiceNumber &&
      prRtvInvoiceNumber.trim() &&
      debitNoteDate &&
      debitNoteDate.trim() &&
      debitNoteAmount &&
      debitNoteAmount.toString().trim() &&
      disputedAmount &&
      disputedAmount.toString().trim() &&
      prRtvRemark &&
      prRtvRemark.trim() &&
      prRtvConfirmed &&
      uploadedPrRtvSupportingFiles.length > 0
    );
  };

  // Function to reset form states for both tabs
  const resetFormStates = () => {
    // Reset Invoice Missing Issue form
    setOrganisationName("");
    setInvoiceNumber("");
    setPoNumber("");
    setInvoiceDate("");
    setInvoiceAmount("");
    setConfirmed(false);
    setUploadedPodFiles([]);
    setUploadedInvoiceFiles([]);

    // Reset PR/RTV Issue form
    setPrRtvOrganisationName("");
    setDebitNoteNumber("");
    setPrRtvInvoiceNumber("");
    setDebitNoteDate("");
    setDebitNoteAmount("");
    setDisputedAmount("");
    setPrRtvRemark("");
    setPrRtvConfirmed(false);
    setUploadedPrRtvSupportingFiles([]);
  };

  // Handle Add Issue confirmation
  const handleAddIssueConfirm = async () => {
    setIsLoadingAddNewIssueSubmit(true);

    const bodyFormData = new FormData();

    if (selectedIssueTab === 0) {
      // Invoice Missing Issue data
      bodyFormData.append("organisationName", organisationName || "");
      bodyFormData.append("invoiceNumber", invoiceNumber || "");
      bodyFormData.append("poNumber", poNumber || "");
      bodyFormData.append("date", invoiceDate || "");
      bodyFormData.append("amount", invoiceAmount || "");

      // Add POD files
      for (const file of uploadedPodFiles) {
        bodyFormData.append("POD", file);
      }
      // Add Invoice files
      for (const file of uploadedInvoiceFiles) {
        bodyFormData.append("Others", file);
      }
    } else {
      // PR/RTV Issue data
      bodyFormData.append("organisationName", prRtvOrganisationName || "");
      bodyFormData.append("debitNoteNumber", debitNoteNumber || "");
      bodyFormData.append("invoiceNumber", prRtvInvoiceNumber || "");
      bodyFormData.append("date", debitNoteDate || "");
      bodyFormData.append("amount", debitNoteAmount || "");
      bodyFormData.append("disputedAmount", disputedAmount || "");
      bodyFormData.append("reason", prRtvRemark || "");

      // Add supporting files
      for (const file of uploadedPrRtvSupportingFiles) {
        bodyFormData.append("POD", file);
      }
    }

    const api_endpoint =
      selectedIssueTab === 0 ? API_ENDPOINTS.ADD_NEW_ISSUE_INVOICE : API_ENDPOINTS.ADD_NEW_ISSUE_PRRTV;

    // TODO: Replace with actual API endpoint
    await useFetch(api_endpoint.url, "POST", {
      failureMessage: api_endpoint.failureMessage,
      showSuccessToast: true,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      data: bodyFormData,
      thenCallBack: (_response) => {
        listVendorPortalDr(token, isNonReconViewRaisedIssues);
        setIsLoadingAddNewIssueSubmit(false);
        // Close modal and reset form
        setOpenAddIssueConfirmModal(false);

        // Reset all form states
        resetFormStates();
      },
      catchCallBack: () => {
        setIsLoadingAddNewIssueSubmit(false);
        setOpenAddIssueConfirmModal(false);
      },
    });
  };

  // Handle Bulk Add Issue - separate API call for bulk uploads
  const handleAddBulkIssue = async (file) => {
    if (!file) return;

    setIsLoadingAddNewIssueSubmit(true);

    const bodyFormData = new FormData();

    // Determine issue type based on current tab
    const api_endpoint =
      selectedIssueTab === 0 ? API_ENDPOINTS.ADD_BULK_ISSUE_INVOICE : API_ENDPOINTS.ADD_BULK_ISSUE_PRRTV;
    const issueType = selectedIssueTab === 0 ? "INVOICE_MISSING" : "PR_RTV";

    bodyFormData.append("file", file);

    // TODO: Replace with actual bulk API endpoint
    await useFetch(api_endpoint.url, "POST", {
      failureMessage: api_endpoint.failureMessage,
      // showSuccessToast: true,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      data: bodyFormData,
      thenCallBack: (response) => {
        listVendorPortalDr(token, isNonReconViewRaisedIssues);
        setIsLoadingAddNewIssueSubmit(false);

        // Map API response to UI format based on issue type
        const mapValidationDataForUI = (responseData, issueType) => {
          let validationMapping = {};

          if (issueType === "INVOICE_MISSING") {
            // Invoice mapping structure - predefined text and status mapping
            validationMapping = {
              successfullyRaisedIssues: {
                validation: "Successfully raised issues",
                status: "success",
              },
              accountedInInstamartLedger: {
                validation: "Accounted in Instamart ledger",
                status: "error",
              },
              invoiceAlreadyPresentInReconDisputedEntries: {
                validation: "Invoice already present in recon disputed entries",
                status: "error",
              },
              alreadyRaisedAnIssueForThisInvoice: {
                validation: "Already raised an issue for this invoice",
                status: "error",
              },
              validationErrors: {
                validation: "Validation errors",
                status: "error",
              },
              totalProcessed: {
                validation: "Total processed",
                status: "success",
              },
            };
          } else if (issueType === "PR_RTV") {
            // PR/RTV mapping structure - predefined text and status mapping
            validationMapping = {
              successfullyRaisedIssues: {
                validation: "Successfully raised issues",
                status: "success",
              },
              prRTVAlreadyPresent: {
                validation: "Already raised an issue for this debit note",
                status: "error",
              },
              validationErrors: {
                validation: "Validation errors",
                status: "error",
              },
              totalProcessed: {
                validation: "Total processed",
                status: "success",
              },
            };
          }

          // Map response data to UI format using the predefined mapping
          const validationData = Object.keys(validationMapping)
            .filter((key) => responseData[key] && responseData[key] > 0)
            .map((key) => ({
              validation: validationMapping[key].validation,
              status: validationMapping[key].status,
              count: responseData[key],
            }));

          return validationData;
        };

        // Map response data to UI format
        const mappedValidationData = mapValidationDataForUI(response.data?.data?.validationResults, issueType);
        setBulkValidationData(mappedValidationData);
        setShowBulkValidationModal(true);

        // Show success message
        toast.success(<CustomToast message="Bulk issues uploaded successfully!" />);
      },
      catchCallBack: () => {
        setIsLoadingAddNewIssueSubmit(false);
      },
    });
  };

  return (
    <div>
      {showAddNewIssue ? (
        // Add New Issue Page
        <Box sx={{ p: 4, bgcolor: "#ffffff", borderRadius: 1 }}>
          {/* Back button and Header */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
            <CustomButton
              size="medium"
              variant="text"
              colorToken="violet"
              startIcon={<ChevronLeftIcon />}
              onClick={() => setShowAddNewIssue(false)}
            >
              Back
            </CustomButton>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "24px",
                lineHeight: 1.3,
                color: "rgba(0,0,0,0.87)",
                letterSpacing: "0.03px",
              }}
            >
              Add New Issue
            </Typography>
          </Box>

          {/* Main Container */}
          <Box sx={{ bgcolor: "#ffffff", borderRadius: 1, overflow: "hidden" }}>
            {/* Header with Tabs */}
            <Box
              sx={{
                bgcolor: "#ffffff",
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                // borderTop: "1px solid rgba(0,0,0,0.12)",
                // borderLeft: "1px solid rgba(0,0,0,0.12)",
                // borderRight: "1px solid rgba(0,0,0,0.12)",
                // borderTopLeftRadius: 8,
                // borderTopRightRadius: 8,
              }}
            >
              <Box>
                <Tabs
                  value={selectedIssueTab}
                  onChange={(_, newValue) => {
                    setSelectedIssueTab(newValue);
                    resetFormStates();
                  }}
                  sx={{
                    "& .MuiTab-root": {
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: "16px",
                      textTransform: "none",
                      color: "rgba(0,0,0,0.6)",
                      "&.Mui-selected": {
                        color: "#541c4c",
                      },
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#541c4c",
                      height: 2,
                    },
                  }}
                >
                  <Tab label="Invoice Missing Issue" />
                  <Tab label="PR/ RTV Issue" />
                </Tabs>
              </Box>
            </Box>

            {/* Alert */}
            <Box sx={{ py: 2.5 }}>
              <Alert
                severity="info"
                sx={{
                  backgroundColor: "#e5f6fd",
                  color: "#014361",
                  "& .MuiAlert-icon": {
                    color: "#0288d1",
                  },
                }}
              >
                {selectedIssueTab === 0
                  ? "This page is only for invoice missing issues, raise an invoice issue only if your invoice is not found in Instamart ledger/summary."
                  : "This page is only for PR/RTV issues, raise an issue only if you dispute PR/RTV debit note found in the ledger."}
              </Alert>
            </Box>

            {/* Form Content */}
            <Box sx={{ bgcolor: "#ffffff", border: "1px solid rgba(0,0,0,0.12)" }}>
              {/* Add Issue Header */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 5,
                  py: 2,
                  bgcolor: "#ffffff",
                  borderBottom: "1px solid rgba(0,0,0,0.12)",
                }}
              >
                <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "rgba(0,0,0,0.87)" }}>Add Issue</Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <CustomButton
                    size="small"
                    variant={
                      selectedIssueTab === 0
                        ? invoiceMissingMode === "manual"
                          ? "contained"
                          : "outlined"
                        : prRtvMode === "manual"
                        ? "contained"
                        : "outlined"
                    }
                    colorToken="violet"
                    onClick={() => {
                      if (selectedIssueTab === 0) {
                        setInvoiceMissingMode("manual");
                      } else {
                        setPrRtvMode("manual");
                      }
                    }}
                  >
                    Manually
                  </CustomButton>
                  <CustomButton
                    size="small"
                    variant={
                      selectedIssueTab === 0
                        ? invoiceMissingMode === "bulk"
                          ? "contained"
                          : "outlined"
                        : prRtvMode === "bulk"
                        ? "contained"
                        : "outlined"
                    }
                    colorToken="violet"
                    onClick={() => {
                      if (selectedIssueTab === 0) {
                        setInvoiceMissingMode("bulk");
                      } else {
                        setPrRtvMode("bulk");
                      }
                    }}
                  >
                    Bulk
                  </CustomButton>
                </Box>
              </Box>

              {/* Conditional Rendering Based on Tab and Mode */}
              {selectedIssueTab === 0 ? (
                // Invoice Missing Issue Tab
                <>
                  {invoiceMissingMode === "manual" ? (
                    // Invoice Missing Issue - Manual Form
                    <>
                      {/* Form Fields */}
                      <Box sx={{ bgcolor: "#fafafa", px: 5, py: 2.5, borderBottom: "1px solid rgba(0,0,0,0.12)" }}>
                        {/* Organisation Name - First Row */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                            Organisation Name <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <Autocomplete
                            fullWidth
                            size="small"
                            options={allCompanies}
                            value={allCompanies.find((company) => company.companyName === organisationName) || null}
                            getOptionLabel={(option) => option.companyName || ""}
                            onChange={(_event, newValue) => {
                              setOrganisationName(newValue?.companyName || "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select from dropdown"
                                className="update-custom-border-radius"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#ffffff",
                                  },
                                }}
                              />
                            )}
                          />
                        </Box>

                        {/* Invoice Number and PO Number - Second Row */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Invoice Number <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              placeholder="Enter Invoice Number"
                              value={invoiceNumber}
                              onChange={(e) => setInvoiceNumber(e.target.value)}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              PO Number <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              placeholder="Enter PO Number"
                              value={poNumber}
                              onChange={(e) => setPoNumber(e.target.value)}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Invoice Date and Invoice Amount - Third Row */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Invoice Date <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              type="date"
                              value={invoiceDate}
                              onChange={(e) => setInvoiceDate(e.target.value)}
                              size="small"
                              className="update-custom-border-radius"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                max: (() => {
                                  const yesterday = new Date();
                                  yesterday.setDate(yesterday.getDate() - 1);
                                  return yesterday.toISOString().split("T")[0];
                                })(),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Invoice Amount <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <MonetaryInput
                              fullWidth
                              placeholder="Enter Invoice Amount"
                              value={invoiceAmount}
                              setValue={(val: number) => setInvoiceAmount(val.toString())}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>

                      {/* File Upload Section */}
                      <Box
                        sx={{
                          bgcolor: "#fafafa",
                          px: 5,
                          py: 2.5,
                          borderBottom: "1px solid rgba(0,0,0,0.12)",
                          borderBottomLeftRadius: 8,
                          borderBottomRightRadius: 8,
                        }}
                      >
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2.5 }}>
                          {/* Upload POD Document Section */}
                          <Card sx={{ border: "1px solid #d6d6d6" }}>
                            <CardContent sx={{ padding: "16px 24px" }}>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Box>
                                  <Typography className="heading-xs">Upload POD*</Typography>
                                  <Typography className="body-s-medium" color="textSecondary">
                                    Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                                  </Typography>
                                </Box>
                                <>
                                  <Input
                                    type="file"
                                    inputRef={(ref) => setFileInputPod(ref)}
                                    sx={{ display: "none" }}
                                    onChange={handlePODFileUpload}
                                    inputProps={{
                                      accept: ".pdf,.jpg,.png,.xlsx,.xls",
                                      multiple: true,
                                    }}
                                  />
                                  <CustomButton
                                    size="small"
                                    colorToken="violet"
                                    variant="outlined"
                                    startIcon={<Upload />}
                                    onClick={() => fileInputPod?.click()}
                                    disabled={uploadedPodFiles.length >= 10}
                                  >
                                    Upload
                                  </CustomButton>
                                </>
                              </Box>
                            </CardContent>

                            {uploadedPodFiles.map((file, index) => (
                              <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "8px 16px",
                                  backgroundColor: "#f2f2f2",
                                  borderTop: "1px solid #d6d6d6",
                                }}
                              >
                                <Chip
                                  avatar={
                                    <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                                      <Description sx={{ fontSize: 14, color: "white" }} />
                                    </Avatar>
                                  }
                                  label={
                                    <Box
                                      title={file.name}
                                      sx={{
                                        maxWidth: "150px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {file.name}
                                    </Box>
                                  }
                                  variant="outlined"
                                  sx={{
                                    maxWidth: "150px",
                                    borderColor: "#541c4c",
                                    color: "#541c4c",
                                    flex: 1,
                                  }}
                                />
                                <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                                  <CustomButton
                                    size="small"
                                    color="error"
                                    variant="outlined"
                                    startIcon={<Delete />}
                                    onClick={() => handleDeletePodFile(index)}
                                  >
                                    Delete
                                  </CustomButton>
                                </Box>
                              </Box>
                            ))}
                          </Card>

                          {/* Upload Invoice Document Section */}
                          <Card sx={{ border: "1px solid #d6d6d6" }}>
                            <CardContent sx={{ padding: "16px 24px" }}>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Box>
                                  <Typography className="heading-xs">Upload Invoice Document (Optional)</Typography>
                                  <Typography className="body-s-medium" color="textSecondary">
                                    Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                                  </Typography>
                                </Box>
                                <>
                                  <Input
                                    type="file"
                                    inputRef={(ref) => setFileInputInvoice(ref)}
                                    sx={{ display: "none" }}
                                    onChange={handleInvoiceFileUpload}
                                    inputProps={{
                                      accept: ".pdf,.jpg,.png,.xlsx,.xls",
                                      multiple: true,
                                    }}
                                  />
                                  <CustomButton
                                    size="small"
                                    colorToken="violet"
                                    variant="outlined"
                                    startIcon={<Upload />}
                                    onClick={() => fileInputInvoice?.click()}
                                    disabled={uploadedInvoiceFiles.length >= 10}
                                  >
                                    Upload
                                  </CustomButton>
                                </>
                              </Box>
                            </CardContent>

                            {uploadedInvoiceFiles.map((file, index) => (
                              <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "8px 16px",
                                  backgroundColor: "#f2f2f2",
                                  borderTop: "1px solid #d6d6d6",
                                }}
                              >
                                <Chip
                                  avatar={
                                    <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                                      <Description sx={{ fontSize: 14, color: "white" }} />
                                    </Avatar>
                                  }
                                  label={
                                    <Box
                                      title={file.name}
                                      sx={{
                                        maxWidth: "150px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {file.name}
                                    </Box>
                                  }
                                  variant="outlined"
                                  sx={{
                                    maxWidth: "150px",
                                    borderColor: "#541c4c",
                                    color: "#541c4c",
                                    flex: 1,
                                  }}
                                />
                                <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                                  <CustomButton
                                    size="small"
                                    color="error"
                                    variant="outlined"
                                    startIcon={<Delete />}
                                    onClick={() => handleDeleteInvoiceFile(index)}
                                  >
                                    Delete
                                  </CustomButton>
                                </Box>
                              </Box>
                            ))}
                          </Card>
                        </Box>

                        {/* Confirmation Checkbox */}
                        <Box sx={{ mb: 2.5, mt: 2.5 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={confirmed}
                                onChange={(e) => setConfirmed(e.target.checked)}
                                sx={{
                                  color: "#541c4c",
                                  "&.Mui-checked": {
                                    color: "#541c4c",
                                  },
                                }}
                              />
                            }
                            label="I confirm that I have checked this invoice in the ledger and not found."
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontFamily: "Roboto",
                                fontSize: "16px",
                                color: "rgba(0,0,0,0.87)",
                              },
                            }}
                          />
                        </Box>

                        {/* Add Issue Button */}
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                          <CustomButton
                            size="small"
                            variant="contained"
                            colorToken="violet"
                            disabled={!isInvoiceMissingFormValid()}
                            onClick={handleAddIssueClick}
                          >
                            Add Issue
                          </CustomButton>
                        </Box>
                      </Box>
                    </>
                  ) : (
                    // Invoice Missing Issue - Bulk Upload
                    <Box
                      sx={{
                        bgcolor: "#fafafa",
                        px: 5,
                        py: 2.5,
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8,
                      }}
                    >
                      <Alert
                        severity="info"
                        sx={{
                          backgroundColor: "#e5f6fd",
                          color: "#014361",
                          mb: 3,
                          "& .MuiAlert-icon": {
                            color: "#0288d1",
                          },
                        }}
                      >
                        Upload file in the given file format only.
                      </Alert>

                      {/* Drag and Drop Area */}
                      <Box
                        sx={{
                          border: "2px dashed #d6d6d6",
                          borderRadius: 2,
                          p: 4,
                          textAlign: "center",
                          backgroundColor: "#ffffff",
                          minHeight: 300,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                        }}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                      >
                        <Box
                          sx={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            bgcolor: "#f3e5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 2,
                          }}
                        >
                          <Upload sx={{ fontSize: 40, color: "#541c4c" }} />
                        </Box>
                        <Typography sx={{ fontWeight: 600, fontSize: "20px", mb: 1 }}>Drag and drop sheet</Typography>
                        <Typography sx={{ color: "rgba(0,0,0,0.6)", mb: 3 }}>XLS/CSV formats supported</Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <CustomButton
                            size="medium"
                            variant="outlined"
                            colorToken="violet"
                            disabled={isDownloadingForNonRecon}
                            startIcon={isDownloadingForNonRecon ? <CircularProgress size={16} color="inherit" /> : null}
                            onClick={() => {
                              handleDownloadExcelForNonRecon();
                            }}
                          >
                            Download file format
                          </CustomButton>
                          <CustomButton
                            size="medium"
                            variant="contained"
                            colorToken="violet"
                            onClick={() => fileInputBulk?.click()}
                            disabled={isLoadingAddNewIssueSubmit}
                            startIcon={
                              isLoadingAddNewIssueSubmit ? <CircularProgress size={16} color="inherit" /> : null
                            }
                          >
                            Upload Issues in Bulk
                          </CustomButton>
                        </Box>
                        <Input
                          type="file"
                          inputRef={(ref) => setFileInputBulk(ref)}
                          sx={{ display: "none" }}
                          onChange={handleBulkFileUpload}
                          inputProps={{
                            accept: ".xlsx,.xls,.csv",
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </>
              ) : (
                // PR/RTV Issue Tab
                <>
                  {prRtvMode === "manual" ? (
                    // PR/RTV Issue - Manual Form
                    <>
                      {/* Form Fields */}
                      <Box sx={{ bgcolor: "#fafafa", px: 5, py: 2.5, borderBottom: "1px solid rgba(0,0,0,0.12)" }}>
                        {/* Organisation Name - Third Row */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                            Organisation Name <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <Autocomplete
                            fullWidth
                            size="small"
                            options={allCompanies}
                            value={
                              allCompanies.find((company) => company.companyName === prRtvOrganisationName) || null
                            }
                            getOptionLabel={(option) => option.companyName || ""}
                            onChange={(_event, newValue) => {
                              setPrRtvOrganisationName(newValue?.companyName || "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select from dropdown"
                                className="update-custom-border-radius"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#ffffff",
                                  },
                                }}
                              />
                            )}
                          />
                        </Box>
                        {/* Debit Note Number and Invoice Number - First Row */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Debit Note Number <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              placeholder="Enter Debit Note Number"
                              value={debitNoteNumber}
                              onChange={(e) => setDebitNoteNumber(e.target.value)}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Invoice Number <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              placeholder="Enter Invoice Number"
                              value={prRtvInvoiceNumber}
                              onChange={(e) => setPrRtvInvoiceNumber(e.target.value)}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Debit Note Date and Debit Note Amount - Second Row */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Debit Note Date <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <TextField
                              fullWidth
                              type="date"
                              value={debitNoteDate}
                              onChange={(e) => setDebitNoteDate(e.target.value)}
                              size="small"
                              className="update-custom-border-radius"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                max: (() => {
                                  const yesterday = new Date();
                                  yesterday.setDate(yesterday.getDate() - 1);
                                  return yesterday.toISOString().split("T")[0];
                                })(),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Debit Note Amount <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <MonetaryInput
                              fullWidth
                              placeholder="Enter Debit Note Amount"
                              value={debitNoteAmount}
                              setValue={(val: number) => setDebitNoteAmount(val.toString())}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Disputed Amount - Third Row */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                              Disputed Amount <span style={{ color: "#d32f2f" }}>*</span>
                            </Typography>
                            <MonetaryInput
                              fullWidth
                              placeholder="Enter Disputed Amount"
                              value={disputedAmount}
                              setValue={(val: number) => setDisputedAmount(val.toString())}
                              size="small"
                              className="update-custom-border-radius"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#ffffff",
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Remark - Fourth Row */}
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontWeight: 500, fontSize: "14px", mb: 1, color: "rgba(0,0,0,0.87)" }}>
                            Reason of Issue? <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            placeholder="Enter Issue Reason"
                            value={prRtvRemark}
                            onChange={(e) => setPrRtvRemark(e.target.value)}
                            size="small"
                            className="update-custom-border-radius"
                            multiline
                            rows={3}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#ffffff",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      {/* File Upload Section */}
                      <Box
                        sx={{
                          bgcolor: "#fafafa",
                          px: 5,
                          py: 2.5,
                          borderBottomLeftRadius: 8,
                          borderBottomRightRadius: 8,
                        }}
                      >
                        {/* Upload Supporting Document Section */}
                        <Card sx={{ border: "1px solid #d6d6d6", mb: 2.5 }}>
                          <CardContent sx={{ padding: "16px 24px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Box>
                                <Typography className="heading-xs">Upload Supporting Document (POD)*</Typography>
                                <Typography className="body-s-medium" color="textSecondary">
                                  Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                                </Typography>
                              </Box>
                              <>
                                <Input
                                  type="file"
                                  inputRef={(ref) => setFileInputPrRtvSupporting(ref)}
                                  sx={{ display: "none" }}
                                  onChange={handlePrRtvSupportingFileUpload}
                                  inputProps={{
                                    accept: ".pdf,.jpg,.png,.xlsx,.xls",
                                    multiple: true,
                                  }}
                                />
                                <CustomButton
                                  size="small"
                                  colorToken="violet"
                                  variant="outlined"
                                  startIcon={<Upload />}
                                  onClick={() => fileInputPrRtvSupporting?.click()}
                                  disabled={uploadedPrRtvSupportingFiles.length >= 10}
                                >
                                  Upload
                                </CustomButton>
                              </>
                            </Box>
                          </CardContent>

                          {uploadedPrRtvSupportingFiles.map((file, index) => (
                            <Box
                              key={index}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "8px 16px",
                                backgroundColor: "#f2f2f2",
                                borderTop: "1px solid #d6d6d6",
                              }}
                            >
                              <Chip
                                avatar={
                                  <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                                    <Description sx={{ fontSize: 14, color: "white" }} />
                                  </Avatar>
                                }
                                label={
                                  <Box
                                    title={file.name}
                                    sx={{
                                      maxWidth: "150px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {file.name}
                                  </Box>
                                }
                                variant="outlined"
                                sx={{
                                  maxWidth: "150px",
                                  borderColor: "#541c4c",
                                  color: "#541c4c",
                                  flex: 1,
                                }}
                              />
                              <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                                <CustomButton
                                  size="small"
                                  color="error"
                                  variant="outlined"
                                  startIcon={<Delete />}
                                  onClick={() => handleDeletePrRtvSupportingFile(index)}
                                >
                                  Delete
                                </CustomButton>
                              </Box>
                            </Box>
                          ))}
                        </Card>

                        {/* Confirmation Checkbox */}
                        <Box sx={{ mb: 2.5 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={prRtvConfirmed}
                                onChange={(e) => setPrRtvConfirmed(e.target.checked)}
                                sx={{
                                  color: "#541c4c",
                                  "&.Mui-checked": {
                                    color: "#541c4c",
                                  },
                                }}
                              />
                            }
                            label="I confirm that I have checked this debit note in the ledger and have a dispute."
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontFamily: "Roboto",
                                fontSize: "16px",
                                color: "rgba(0,0,0,0.87)",
                              },
                            }}
                          />
                        </Box>

                        {/* Add Issue Button */}
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                          <CustomButton
                            size="small"
                            variant="contained"
                            colorToken="violet"
                            disabled={!isPrRtvFormValid()}
                            onClick={handleAddIssueClick}
                          >
                            Add Issue
                          </CustomButton>
                        </Box>
                      </Box>
                    </>
                  ) : (
                    // PR/RTV Issue - Bulk Upload (same as Invoice Missing Issue)
                    <Box
                      sx={{
                        bgcolor: "#fafafa",
                        px: 5,
                        py: 2.5,
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8,
                      }}
                    >
                      <Alert
                        severity="info"
                        sx={{
                          backgroundColor: "#e5f6fd",
                          color: "#014361",
                          mb: 3,
                          "& .MuiAlert-icon": {
                            color: "#0288d1",
                          },
                        }}
                      >
                        Upload file in the given file format only.
                      </Alert>

                      {/* Drag and Drop Area */}
                      <Box
                        sx={{
                          border: "2px dashed #d6d6d6",
                          borderRadius: 2,
                          p: 4,
                          textAlign: "center",
                          backgroundColor: "#ffffff",
                          minHeight: 300,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                        }}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                      >
                        <Box
                          sx={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            bgcolor: "#f3e5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 2,
                          }}
                        >
                          <Upload sx={{ fontSize: 40, color: "#541c4c" }} />
                        </Box>
                        <Typography sx={{ fontWeight: 600, fontSize: "20px", mb: 1 }}>Drag and drop sheet</Typography>
                        <Typography sx={{ color: "rgba(0,0,0,0.6)", mb: 3 }}>XLS/CSV formats supported</Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <CustomButton
                            size="medium"
                            variant="outlined"
                            colorToken="violet"
                            onClick={() => {
                              handleDownloadExcelForNonRecon();
                            }}
                          >
                            Download file format
                          </CustomButton>
                          <CustomButton
                            size="medium"
                            variant="contained"
                            colorToken="violet"
                            onClick={() => fileInputBulk?.click()}
                          >
                            Upload Issues in Bulk
                          </CustomButton>
                        </Box>
                        <Input
                          type="file"
                          inputRef={(ref) => setFileInputBulk(ref)}
                          sx={{ display: "none" }}
                          onChange={handleBulkFileUpload}
                          inputProps={{
                            accept: ".xlsx,.xls,.csv",
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </>
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{ p: 4, pt: 1, bgcolor: "#ffffff", borderRadius: 1 }}>
          {/* Header */}
          {!showDetailSummaryTable ? (
            <>
              {/* Header with Organization Select and Navigation Buttons */}
              {/* here need title */}
              <Typography variant="h6" sx={{ pb: 2, pt: 0 }}>
                {isNonReconViewRaisedIssues ? "Other Issues Dashboard" : "Recon-Gap Entries Dashboard"}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  {/* {isNonReconViewRaisedIssues && (
                    <CustomButton
                      size="medium"
                      variant="text"
                      colorToken="violet"
                      startIcon={<ChevronLeftIcon />}
                      onClick={() => {
                        handleReconOrNonReconView(false);
                      }}
                    >
                      Back
                    </CustomButton>
                  )} */}
                  <FormControl sx={{ minWidth: 220 }} className="update-custom-border-radius">
                    <InputLabel id="organization-select-label">Select Organisation Name</InputLabel>
                    <Select
                      labelId="organization-select-label"
                      value={selectedOrganization}
                      label="Select Organisation Name"
                      onChange={(e) => changeOrganization(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    >
                      <MenuItem value="All">All</MenuItem>

                      {allOrganizations.map((org, index) => (
                        <MenuItem key={index} value={org}>
                          {org}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* {!isNonReconViewRaisedIssues && ( */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  {isNonReconViewRaisedIssues ? (
                    <CustomButton
                      size="medium"
                      variant="outlined"
                      // endIcon={<KeyboardArrowDown />}
                      onClick={() => {
                        setNonReconIssuesMenuAnchor(null);
                        setShowAddNewIssue(true);
                      }}
                      sx={{
                        borderColor: "#d32f2f",
                        color: "#d32f2f",
                        "&:hover": {
                          borderColor: "#d32f2f",
                          backgroundColor: "rgba(211, 47, 47, 0.04)",
                        },
                      }}
                    >
                      Add New Issue
                    </CustomButton>
                  ) : (
                    <CustomButton
                      size="medium"
                      variant="outlined"
                      colorToken="violet"
                      endIcon={<ArrowForward />}
                      onClick={() => window.open("/vendorPortal/reconciliation", "_blank")}
                    >
                      View Linked Reconciliation
                    </CustomButton>
                  )}

                  {/* <CustomButton
                      size="medium"
                      variant="outlined"
                      endIcon={<KeyboardArrowDown />}
                      onClick={(event) => setNonReconIssuesMenuAnchor(event.currentTarget)}
                      sx={{
                        borderColor: "#d32f2f",
                        color: "#d32f2f",
                        "&:hover": {
                          borderColor: "#d32f2f",
                          backgroundColor: "rgba(211, 47, 47, 0.04)",
                        },
                      }}
                    >
                      Raise Other Issues
                    </CustomButton> */}
                </Box>
                {/* )} */}
                {/* Non-Recon Issues Dropdown Menu */}
                <Menu
                  anchorEl={nonReconIssuesMenuAnchor}
                  open={isNonReconIssuesMenuOpen}
                  onClose={() => setNonReconIssuesMenuAnchor(null)}
                  sx={{
                    "& .MuiPaper-root": {
                      border: "1px solid rgba(0,0,0,0.12)",
                      borderRadius: 1,
                      boxShadow:
                        "0px 3px 14px 2px rgba(0,0,0,0.12), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 5px 5px -3px rgba(0,0,0,0.2)",
                      mt: 1,
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setNonReconIssuesMenuAnchor(null);
                      setShowAddNewIssue(true);
                    }}
                    sx={{
                      fontSize: "16px",
                      fontFamily: "Inter",
                      px: 2,
                      py: 0.75,
                      "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.04)",
                      },
                    }}
                  >
                    Add New Issue
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleReconOrNonReconView(true);
                    }}
                    sx={{
                      fontSize: "16px",
                      fontFamily: "Inter",
                      px: 2,
                      py: 0.75,
                      "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.04)",
                      },
                    }}
                  >
                    View Raised Issues
                  </MenuItem>
                </Menu>
                {/*  */}
              </Box>

              {/* Enhanced Summary Cards with Collapsible Sections */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 4 }}>
                {/* Pending Section */}
                {(() => {
                  const summaryData = consolidatedSummaryData.length > 0 ? consolidatedSummaryData : [];
                  const { pending, resolved, pendingItems, resolvedItems } = calculateSectionTotals(summaryData);

                  return (
                    <>
                      <Box
                        sx={{
                          backgroundColor: "#fafafa",
                          borderRadius: 1,
                          border: "1px solid rgba(0,0,0,0.12)",
                          overflow: "hidden",
                        }}
                      >
                        {/* Pending Header */}
                        <Box
                          sx={{
                            px: 3,
                            py: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "pointer",
                          }}
                          onClick={() => setPendingExpanded(!pendingExpanded)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                fontSize: "20px",
                                lineHeight: 1.3,
                                color: "rgba(0,0,0,0.87)",
                                letterSpacing: "0.03px",
                              }}
                            >
                              Pending
                            </Typography>
                            {loaderListVendorPortalDr ? (
                              <>
                                <CircularProgress color="inherit" size={24} />
                              </>
                            ) : (
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontWeight: 600,
                                  fontSize: "20px",
                                  lineHeight: 1.3,
                                  color: "rgba(0,0,0,0.87)",
                                  letterSpacing: "0.03px",
                                }}
                              >
                                ₹{pending.amount.toLocaleString("en-IN")} ({pending.count})
                              </Typography>
                            )}
                          </Box>
                          <IconButton size="small">{pendingExpanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
                        </Box>

                        {/* Pending Content */}
                        <Collapse in={pendingExpanded}>
                          <Box sx={{ px: 3, pb: 2 }}>
                            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 1 }}>
                              {pendingItems.map((data, index) => (
                                <EnhancedSummaryCard
                                  key={index}
                                  data={data}
                                  onViewDetails={() => handleViewDetails(data)}
                                />
                              ))}
                            </Box>
                          </Box>
                        </Collapse>
                      </Box>

                      {/* Resolved Section */}
                      <Box
                        sx={{
                          backgroundColor: "#fafafa",
                          borderRadius: 1,
                          border: "1px solid rgba(0,0,0,0.12)",
                          overflow: "hidden",
                        }}
                      >
                        {/* Resolved Header */}
                        <Box
                          sx={{
                            px: 3,
                            py: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "pointer",
                          }}
                          onClick={() => setResolvedExpanded(!resolvedExpanded)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                fontSize: "20px",
                                lineHeight: 1.3,
                                color: "rgba(0,0,0,0.87)",
                                letterSpacing: "0.03px",
                              }}
                            >
                              Resolved
                            </Typography>
                            {loaderListVendorPortalDr ? (
                              <>
                                <CircularProgress color="inherit" size={24} />
                              </>
                            ) : (
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontWeight: 600,
                                  fontSize: "20px",
                                  lineHeight: 1.3,
                                  color: "rgba(0,0,0,0.87)",
                                  letterSpacing: "0.03px",
                                }}
                              >
                                ₹{resolved.amount.toLocaleString("en-IN")} ({resolved.count})
                              </Typography>
                            )}
                          </Box>
                          <IconButton size="small">{resolvedExpanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
                        </Box>

                        {/* Resolved Content */}
                        <Collapse in={resolvedExpanded}>
                          <Box sx={{ px: 3, pb: 2 }}>
                            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 1 }}>
                              {resolvedItems.map((data, index) => (
                                <EnhancedSummaryCard
                                  key={index}
                                  data={data}
                                  onViewDetails={() => handleViewDetails(data)}
                                />
                              ))}
                            </Box>
                          </Box>
                        </Collapse>
                      </Box>
                    </>
                  );
                })()}
              </Box>

              {/* Enhanced Disclaimer */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1,
                  p: 2,
                  borderRadius: 1,
                  border: "1px solid rgba(0,0,0,0.12)",
                  backgroundColor: "#fafafa",
                  mb: 4,
                }}
              >
                <Info sx={{ fontSize: 24, color: "rgba(0,0,0,0.6)", mt: 0.25 }} />
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: 1.5,
                    color: "rgba(0,0,0,0.6)",
                    letterSpacing: "0.08px",
                  }}
                >
                  Disclaimer: Entries marked as "resolved" are based on actions by Instamart and the Vendor and are
                  assumed to be rectified in their ledgers. Final verification will occur after sharing the updated
                  ledger while signing-off.
                </Typography>
              </Box>
            </>
          ) : (
            //   {/* Disputed Entry Details Section */}
            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography
                  className="heading-m"
                  sx={{
                    color: "rgba(0,0,0,0.87)",
                  }}
                >
                  <IconButton
                    size="small"
                    sx={{ color: "#531c4c", mr: 1 }}
                    onClick={() => {
                      setShowDetailSummaryTable(false);
                      setFilters([]);
                    }}
                  >
                    <Tooltip title="Back to Summary">
                      <ArrowBack />
                    </Tooltip>
                  </IconButton>
                  {isNonReconViewRaisedIssues ? "Other Disputed Entry Details" : "Disputed Entry Details"}
                </Typography>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="outlined"
                    startIcon={<FilterList />}
                    onClick={() => {
                      isNonReconViewRaisedIssues
                        ? setOpenNonReconFilterOfDisputedEntries(true)
                        : setOpenFilterOfDisputedEntries(true);
                    }}
                  >
                    Filter
                  </CustomButton>
                  {/* <CustomButton
                  size="medium"
                  colorToken="violet"
                  variant="contained"
                  startIcon={<FileUpload />}
                  // onClick={()=>{
                  //     setOpenVpUploadDocument(true)
                  // }}
                >
                  Upload Documents
                </CustomButton> */}
                  <CustomButton
                    size="medium"
                    colorToken="violet"
                    variant="contained"
                    onClick={() => setOpenBulkActionModal(true)}
                    disabled={Object.keys(selectedRows).length === 0}
                  >
                    Bulk Actions
                  </CustomButton>
                  <IconButton
                    size="small"
                    onClick={handleDownloadExcel}
                    sx={{
                      color: "#531c4c",
                      "&:hover": {
                        backgroundColor: "rgba(83, 28, 76, 0.04)",
                      },
                    }}
                    disabled={isDownloading}
                  >
                    <Tooltip title="Download Excel">
                      {isDownloading ? (
                        <CircularProgress size={24} color="inherit" /> // Show loading icon
                      ) : (
                        <GetApp />
                      )}
                    </Tooltip>
                  </IconButton>
                </Box>
              </Box>

              {/* Filters Bar */}
              {filters?.some((f) =>
                Array.isArray(f.value)
                  ? f.value.some((v) => v !== null && v !== undefined && v !== "")
                  : f.value !== null && f.value !== undefined && f.value !== ""
              ) && <RejectedInvoicesFiltersBars filters={filters} setFilters={setFilters} />}

              {/* ReactTable */}
              <ReactTable
                columns={isNonReconViewRaisedIssues ? columnDefinitionNonRecon : columnDefinition}
                rows={disputedEntriesData}
                loading={tableLoader}
                enableColumnResizing={true}
                enableRowSelection={true}
                enableColumnPinning={true}
                onColumnFiltersChange={setFilters}
                onRowSelectionChange={setSelectedRows}
                additionalState={{
                  columnFilters: filters,
                  rowSelection: selectedRows,
                  columnPinning: {
                    right: ["actions"],
                  },
                }}
                // getRowId={(row) => row.id}
                enableGlobalFilter={true}
                internalActionsOrder={["filterToggle", "showHideColumns", "fullScreenToggle"]}
                initialState={{
                  showColumnFilters: true,
                  columnPinning: {
                    left: ["resolutionStatus"],
                    right: ["actions"],
                  },
                  columnVisibility: {
                    dependency: false,
                  },
                }}
                setSelectedRow={setSelectedRows}
              />
            </Box>
          )}
        </Box>
      )}

      {openRemarksModal && (
        <VpRemarksDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openRemarksModal={openRemarksModal}
          setOpenRemarksModal={setOpenRemarksModal}
        />
      )}
      {openNonReconRemarksModal && (
        <NonReconVpRemarksDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openRemarksModal={openNonReconRemarksModal}
          setOpenRemarksModal={setOpenNonReconRemarksModal}
        />
      )}
      {/* {openViewHistoryModal && (
                <ViewHistoryDisputedEntries
                  selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
                  openViewHistoryModal={openViewHistoryModal}
                  setOpenViewHistoryModal={setOpenViewHistoryModal}
                />
              )} */}
      {openEntryDetailsModal && (
        <VpEntryDetailsDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openEntryDetailsModal={openEntryDetailsModal}
          setOpenEntryDetailsModal={setOpenEntryDetailsModal}
        />
      )}

      {openTakeActionModal && (
        <VpTakeActionDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openTakeActionModal={openTakeActionModal}
          setOpenTakeActionModal={setOpenTakeActionModal}
          listVendorPortalDr={listVendorPortalDr}
        />
      )}
      {openNonReconTakeActionModal && (
        <NonReconVpTakeActionDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openTakeActionModal={openNonReconTakeActionModal}
          setOpenTakeActionModal={setOpenNonReconTakeActionModal}
          listVendorPortalDr={listVendorPortalDr}
        />
      )}
      {openBulkActionModal && (
        <VpBulkActionDisputedEntries
          selectedRows={Object.keys(selectedRows)
            .filter((key) => selectedRows[key])
            .map((index) => disputedEntriesData[parseInt(index)])}
          openBulkActionModal={openBulkActionModal}
          setOpenBulkActionModal={setOpenBulkActionModal}
          setSelectedRows={setSelectedRows}
          listVendorPortalDr={listVendorPortalDr}
          isNonReconViewRaisedIssues={isNonReconViewRaisedIssues}
        />
      )}
      {openFilterOfDisputedEntries && (
        <VpFilterOfDisputedEntries
          openFilterOfDisputedEntries={openFilterOfDisputedEntries}
          setOpenFilterOfDisputedEntries={setOpenFilterOfDisputedEntries}
          filters={filters}
          setFilters={setFilters}
          data={disputedEntriesData}
        />
      )}
      {openNonReconFilterOfDisputedEntries && (
        <NonReconVpFilterOfDisputedEntries
          openFilterOfDisputedEntries={openNonReconFilterOfDisputedEntries}
          setOpenFilterOfDisputedEntries={setOpenNonReconFilterOfDisputedEntries}
          filters={filters}
          setFilters={setFilters}
          data={disputedEntriesData}
        />
      )}

      {openVpUploadDocument && (
        <VpUploadDocument
          openVpUploadDocument={openVpUploadDocument}
          setOpenVpUploadDocument={setOpenVpUploadDocument}
        />
      )}

      {/* Add Issue Confirmation Modal */}
      {openAddIssueConfirmModal && (
        <Dialog
          open={openAddIssueConfirmModal}
          onClose={() => setOpenAddIssueConfirmModal(false)}
          maxWidth={DIALOG_MAX_WIDTHS.SM}
          fullWidth
        >
          <DialogTitle className="dialog-title">
            <div className="heading-m">Are you sure?</div>
            <div className="vertical_center_align">
              <IconButton onClick={() => setOpenAddIssueConfirmModal(false)}>
                <Close />
              </IconButton>
            </div>
          </DialogTitle>

          <DialogContent dividers>
            <Box>
              <Alert severity="info">Issue will be added to the Other Issues</Alert>
            </Box>
          </DialogContent>

          <DialogActions>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="text"
              onClick={() => {
                setOpenAddIssueConfirmModal(false);
              }}
            >
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={isLoadingAddNewIssueSubmit}
              startIcon={isLoadingAddNewIssueSubmit ? <CircularProgress size={16} color="inherit" /> : null}
              onClick={() => {
                handleAddIssueConfirm();
              }}
            >
              Confirm
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}

      {/* Bulk Upload Validation Modal */}
      {showBulkValidationModal && (
        <Dialog
          open={showBulkValidationModal}
          onClose={() => setShowBulkValidationModal(false)}
          maxWidth={DIALOG_MAX_WIDTHS.MD}
          fullWidth
          aria-labelledby="bulk-validation-dialog-title"
        >
          <DialogTitle
            id="bulk-validation-dialog-title"
            sx={{
              bgcolor: "rgba(0, 0, 0, 0.04)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Uploaded file validations</Typography>
            <IconButton onClick={() => setShowBulkValidationModal(false)} size="small">
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 0 }}>
            <Box sx={{ p: 3 }}>
              <Alert severity="info" sx={{ mb: 2, bgcolor: "#e5f6fd" }} icon={<Info sx={{ color: "#0288d1" }} />}>
                <Typography variant="body2" sx={{ color: "#014361" }}>
                  This is the breakup of the validations of the uploaded entries
                </Typography>
              </Alert>

              <Box sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", overflow: "hidden" }}>
                {/* Table Header */}
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: "#fafafa",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      p: 2,
                      borderRight: "1px solid #e0e0e0",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      Validations
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "120px",
                      p: 2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      Count
                    </Typography>
                  </Box>
                </Box>

                {/* Success Rows - Dynamically render based on API response */}
                {bulkValidationData
                  ?.filter((item) => item.status === "success")
                  ?.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        bgcolor: "#e8f5e9",
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          p: 2,
                          borderRight: "1px solid #e0e0e0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.87)" }} className="body-s-bold">
                          {item.validation}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          width: "120px",
                          p: 2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" className="body-s-bold" sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
                          {item.count}
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                {/* Error Rows - Dynamically render based on API response */}
                {bulkValidationData
                  ?.filter((item) => item.status === "error")
                  ?.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        borderBottom:
                          index === bulkValidationData.filter((item) => item.status === "error").length - 1
                            ? "none"
                            : "1px solid #e0e0e0",
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          p: 2,
                          borderRight: "1px solid #e0e0e0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "#D32F2F" }} className="body-s-bold">
                          {item.validation}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          width: "120px",
                          p: 2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "#D32F2F" }} className="body-s-bold">
                          {item.count}
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                {/* Info Rows - Dynamically render based on API response */}
                {bulkValidationData
                  ?.filter((item) => item.status === "info")
                  ?.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        bgcolor: "#f5f5f5",
                        borderBottom: "none",
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          p: 2,
                          borderRight: "1px solid #e0e0e0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.87)", fontWeight: 600 }}>
                          {item.validation}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          width: "120px",
                          p: 2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ color: "rgba(0, 0, 0, 0.87)", fontWeight: 600 }}>
                          {item.count}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
              </Box>

              {/* Show warning only if there are successfully raised issues */}
              {bulkValidationData?.some(
                (item) => item.validation === "Successfully raised issues" && item.count > 0
              ) && (
                <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    To complete the issue submission, go to{" "}
                    <span
                      style={{ color: "#1976d2", cursor: "pointer" }}
                      onClick={() => {
                        setShowBulkValidationModal(false);
                        setShowAddNewIssue(false);
                        setTitleOfDisputedEntryDetails("Docs Pending by Vendor");
                        setFilters([
                          {
                            id: "dependency",
                            value: ["Vendor"],
                          },
                          {
                            id: "resolutionStatus",
                            value: ["Docs Pending"], // Use the array of original resolution statuses
                          },
                        ]);
                        setShowDetailSummaryTable(true);
                      }}
                    >
                      Docs Pending by Vendor
                    </span>{" "}
                    and upload the supporting documents using <span style={{ fontWeight: "bold" }}>Take Action</span>.
                  </Typography>
                </Alert>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default VpDisputedEntries;
